'use client'

export default function DealTypeTabs({ deals, dealTypeTab, setDealTypeTab }) {
  const handleClick = (key) => {
    if (key === 'award') window.plausible?.('AwardDealsTab', { props: { from: dealTypeTab } })
    setDealTypeTab(key)
  }

  const counts = { all: 0, error_fare: 0, exceptional: 0, deal: 0, good_price: 0 }
  for (const deal of deals) {
    counts.all++
    const t = deal.deal_type
    if (t === 'error_fare')  counts.error_fare++
    else if (t === 'exceptional') counts.exceptional++
    else if (t === 'deal')   counts.deal++
    else if (t === 'good_price') counts.good_price++
    else if (t === 'award')  counts.award = (counts.award ?? 0) + 1
  }

  return (
    <div className="mb-5 flex items-center gap-2 border-b border-gray-200 pb-3 flex-wrap">
      {[
        { key: 'all',        label: 'All Deals' },
        { key: 'error_fare', label: '⚡ Error Fares' },
        { key: 'exceptional',label: '🔥 Exceptional' },
        { key: 'deal',       label: '✅ Good Deal' },
        { key: 'good_price', label: '💚 Good Price' },
        { key: 'award',      label: '✈️ Award Deals', soon: true },
      ].map(({ key, label, soon }) => (
        <button
          key={key}
          onClick={() => handleClick(key)}
          className={`relative rounded-full px-4 py-1.5 text-sm font-semibold transition-colors ${
            dealTypeTab === key
              ? 'bg-gray-900 text-white'
              : 'bg-white text-gray-500 ring-1 ring-gray-200 hover:bg-gray-50'
          }`}
        >
          {label}
          {soon && (
            <span className="ml-1.5 text-[10px] font-bold uppercase tracking-wide text-violet-500">Coming soon</span>
          )}
          {!soon && counts[key] != null && counts[key] > 0 && (
            <span className="ml-1.5 text-xs font-normal opacity-60">({counts[key]})</span>
          )}
        </button>
      ))}
    </div>
  )
}
